var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import TransactionUtils from '@popup/steem/utils/transaction.utils';
export const initAccountTransactions = (accountName, currency) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const memoKey = getState().steem.accounts.find((a) => a.name === accountName).keys.memo;
    const limit = currency.toUpperCase() === 'HIVE' ? 1000 : 999;
    const result = yield TransactionUtils.getAccountTransactions(accountName, currency, -1, limit, memoKey, true);
    dispatch({
        type: SteemActionType.INIT_TRANSACTIONS,
        payload: {
            transactions: result[0],
            nextStart: result[1],
            totalCount: result[2]
        },
    });
});
export const fetchAccountTransactions = (accountName, currency, start, limit, isFirstLoad = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const memoKey = getState().steem.accounts.find((a) => a.name === accountName).keys.memo;
    const result = yield TransactionUtils.getAccountTransactions(accountName, currency, start, limit, memoKey, isFirstLoad);
    dispatch({
        type: isFirstLoad
            ? SteemActionType.INIT_TRANSACTIONS
            : SteemActionType.ADD_TRANSACTIONS,
        payload: {
            transactions: result[0],
            nextStart: result[1],
            totalCount: result[2]
        },
    });
});
